import React from 'react';
import { X } from 'lucide-react';
import { SectionHeader } from '../ui/Shared';
export function ProblemSection() {
  const mistakes = ['El Omeprazol bloquea la digestión, haciendo que la comida se fermente y produzca gases que empujan el ácido hacia arriba.', 'La leche fría te alivia al contacto, pero genera un "efecto rebote" que dispara más acidez 10 minutos después.', 'Dejar el picante no es suficiente si sigues consumiendo los "gatillos silenciosos" como el tomate o el café a deshoras.', 'Dormir sentado es una tortura que daña tu espalda y no soluciona la raíz del problema metabólico.'];
  return <section id="problema" className="py-24" data-id="element-295">
      <div className="max-w-[780px] mx-auto px-6" data-id="element-296">
        <SectionHeader tag="El problema real" title={<>
              Tu esófago está
              <br data-id="element-298" />
              "en carne viva"
            </>} data-id="element-297" />

        <div className="fade-up bg-surface border border-white/5 rounded-xl p-8 mt-10 mb-16" data-id="element-299">
          <p className="text-lg text-text-muted leading-relaxed mb-6" data-id="element-300">
            El problema no es que tengas "mucho ácido". El problema es que tu
            cuerpo ha perdido su escudo natural. Sin una hidratación específica
            y sin la protección adecuada en tu mucosa, tu esófago está sufriendo
            quemaduras reales cada vez que te recuestas.
          </p>
          <p className="text-lg text-text-muted leading-relaxed" data-id="element-301">
            Si sigues bloqueando el ácido con pastillas de por vida, solo estás
            apagando la alarma mientras el incendio sigue destruyendo tus
            cuerdas vocales, inflamando tu hernia hiatal y robándote años de
            energía por no poder descansar.
          </p>
        </div>

        <SectionHeader title="Por qué lo que has intentado no funciona" titleClassName="text-3xl md:text-4xl" data-id="element-302" />

        <ul className="stagger-children list-none mt-10 space-y-4" data-id="element-303">
          {mistakes.map((point, idx) => <li key={idx} className="flex items-start gap-4 p-6 bg-danger/5 border border-danger/10 rounded-xl text-lg text-text-light" data-id="element-304">
              <div className="w-8 h-8 bg-danger/10 rounded-full flex items-center justify-center shrink-0 mt-0.5" data-id="element-305">
                <X className="w-4 h-4 text-danger" data-id="element-306" />
              </div>
              <span className="leading-relaxed" data-id="element-307">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}